import clearIsDirty from '../../actions/clearIsDirty';
import getLgpdOptions from '../../selectors/lgpdOption/getLgpdOptions';
import { getOptionsForFeature } from 'owa-outlook-service-options';
import { orchestrator } from 'satcheljs';
import { saveLgpdOption } from '../../actions/lgpd/lgpdOptionsActions';
import {
    LgpdAdsOptions,
    lgpdAdsOwsOptionsFeatureType,
    createOrUpdateOptionsForAdsFeature,
} from 'owa-ads-ows-options';

const saveLgpdOptionOrchestrator = orchestrator(saveLgpdOption, async () => {
    const options = getLgpdOptions();

    const savedOptions = getOptionsForFeature<LgpdAdsOptions>(lgpdAdsOwsOptionsFeatureType);

    let optInBitToSave: number;

    // If the user tries to save the option without toggling the option, we will change the bit to 1 (explicitly opt-out) to avoid the prompt to prompt again
    if (options == null || options.optInBit === 0) {
        optInBitToSave = 1;
    } else {
        optInBitToSave = options.optInBit;
    }

    const newOptions = {
        ...savedOptions,
        optInBit: optInBitToSave,
    };

    await createOrUpdateOptionsForAdsFeature(lgpdAdsOwsOptionsFeatureType, newOptions);

    clearIsDirty();
});

export default saveLgpdOptionOrchestrator;
